var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgA11Y = function SvgA11Y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 46,
    fill: "#0f3741"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10a5 5 0 1 0 0-10 5 5 0 1 0 0 10m19 2H2a2 2 0 1 0 0 4h13v27.5a2.5 2.5 0 1 0 5 0V29h2v14.5a2.5 2.5 0 1 0 5 0V16h13a2 2 0 1 0 0-4"
  })));
};
export default SvgA11Y;